module.exports = ".upload-widget {\n  position: fixed;\n  right: 10px;\n  bottom: 10px;\n  width: 400px;\n  height: 160px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/upload-assets-widget/upload-assets-widget.component.scss
// module id = ./src/app/components/upload-assets-widget/upload-assets-widget.component.scss
// module chunks = main